module.exports = __webpack_public_path__ + "static/media/damlag.50e859bc.jpg";